import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ardn-range',
  templateUrl: './ardn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class ARDNRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
